export type LgvRadioOption = {
  value: string | number | boolean;
  label: string;
  explanation?: string;
};

type RawRadioOption = {
  label?: string;
  text?: string;
  value?: string | number | boolean | null;
  explanation?: string;
};

export function getYesNoRadioOptions(): LgvRadioOption[] {
  return [
    { label: "Yes", value: true },
    { label: "No", value: false },
  ];
}

export function normalizeQuestionRadioOptions(
  options: RawRadioOption[] | undefined,
): LgvRadioOption[] {
  if (!options?.length) return [];

  return options.map((opt) => {
    const label = String(opt.label ?? opt.text ?? "").trim();
    const value =
      opt.value !== undefined && opt.value !== null ? opt.value : label;
    return {
      value,
      label: label || String(value),
      ...(opt.explanation ? { explanation: opt.explanation } : {}),
    };
  });
}

export function isYesNoRadioOptions(options: LgvRadioOption[]): boolean {
  if (options.length !== 2) return false;

  const labels = options.map((opt) => opt.label.trim().toLowerCase()).sort();
  return labels[0] === "no" && labels[1] === "yes";
}

export function shouldUseTwoOptionRadioCards(
  options: LgvRadioOption[],
): boolean {
  if (options.length !== 2) return false;

  if (isYesNoRadioOptions(options)) return true;

  return options.every((opt) => opt.label.trim().length > 0 && opt.label.trim().length <= 20);
}

export function normalizeCompositeRadioOptions(
  options: RawRadioOption[] | undefined,
): LgvRadioOption[] {
  if (!options?.length) return [];

  return options.map((opt) => {
    const label = String(opt.label ?? opt.text ?? "").trim();
    const value =
      opt.value !== undefined && opt.value !== null
        ? opt.value
        : (opt.label ?? opt.text ?? "");
    return {
      value,
      label: label || String(value),
      ...(opt.explanation ? { explanation: opt.explanation } : {}),
    };
  });
}

export function valuesMatchRadio(
  current: unknown,
  optionValue: string | number | boolean,
): boolean {
  return String(current ?? "") === String(optionValue);
}
